import Alert from 'react-bootstrap/Alert';

function Error(){
    return (
        <Alert variant="warning">
      <Alert.Heading>ERROR</Alert.Heading>
      <p>
       Error Received, please try again
      </p>
      
    </Alert>
    );
    }
    export default Error